exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.spacer[data-v-d6a4f1c0] {\n  margin-top: 40px;\n  margin-bottom: 40px;\n}\n*[data-v-d6a4f1c0]:focus{ outline: none;\n} /* Enlever le border noir horrible sous Chrome (default border color for focused form elements) */\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d6a4f1c0","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/statistics/components/GraphPanel.vue
// module id = 1654
// module chunks = 2